import { createApi } from '@reduxjs/toolkit/query/react';
import cinemasClient from '../common/client/cinemasSearch';
import { axiosBaseQuery } from './base';

export const suiteLogsApi = createApi({
  reducerPath: 'suiteLogsApi',
  baseQuery: axiosBaseQuery(cinemasClient),
  endpoints: (builder) => ({
    getSuiteLogs: builder.query({
      query: ({
        facilityId,
        page = 0,
        pageSize = 15,
        sortDirection,
        filterByDeviceModel,
        filterByActions,
        filterBySerial,
        filterByScreen,
        filterByDateRange,
      }) => {
        return {
          url: `/facilities/${facilityId}/suite_logs`,
          method: 'GET',
          params: {
            limit: pageSize,
            offset: page * pageSize,
            sort_by: sortDirection ? 'updated_at' : undefined,
            sort_order: sortDirection || undefined,
            device_model_id:
              filterByDeviceModel?.map((dm) => dm.id).join(',') || undefined,
            device_serial:
              filterBySerial?.map((sn) => sn.value).join(',') || undefined,
            action_type:
              filterByActions?.map((action) => action.id).join(',') ||
              undefined,
            screen_id: filterByScreen?.map((s) => s.id).join(',') || undefined,
            from_date:
              filterByDateRange?.[0]?.startOf('day').format('YYYY-MM-DD') ||
              undefined,
            to_date:
              filterByDateRange?.[1]?.endOf('day').format('YYYY-MM-DD') ||
              undefined,
          },
        };
      },
      transformResponse: (response) => {
        return {
          logs: response?.suite_logs || [],
          totalCount: response?.count,
          hasMore: response?.has_more,
        };
      },
      keepUnusedDataFor: 28800,
    }),
    getUserInfo: builder.query({
      query: ({ userId }) => {
        return {
          url: `/user_data/${userId}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => {
        return {
          ...(response?.user_data || {}),
        };
      },
      keepUnusedDataFor: 28800,
    }),
  }),
});

export const { useGetSuiteLogsQuery, useGetUserInfoQuery } = suiteLogsApi;
